import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'meli-service' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
